import React from 'react';
import { RouteProp } from '@react-navigation/native';
import useCareTeamMembers from '../../../../../hooks/api/useCareTeamMembers';
import { CareTeamActionButtonFrom } from '../../../../shared/CareTeamForm';
import { ProfilesTabParamList, useGoBack, useProfilesTabNavigation } from '../../../../../utils/appNavigationNames';
import { useConfirmBackNavigationOnDirtyForm } from '../../../../shared/FormExitValidation';
import ProfileHeaderContainer from '../../../../v2BaseComponents/ProfileHeaderContainer';

export type AddCareTeamMemberScreenOwnProps = {};

export type AddCareTeamMemberScreenNavigatorProps = {
    route: RouteProp<ProfilesTabParamList, 'add-care-team'>;
};

export type AddCareTeamMemberScreenProps = AddCareTeamMemberScreenOwnProps & AddCareTeamMemberScreenNavigatorProps;

const AddCareTeamMemberScreen: React.FC<AddCareTeamMemberScreenProps> = ({ route }) => {
    const goBack = useGoBack();
    const navigator = useProfilesTabNavigation();
    useConfirmBackNavigationOnDirtyForm(navigator);
    const { createCareTeamMember, isCreatingCareTeamMember } = useCareTeamMembers({
        medicalProfileId: route.params.profileId,
        onCreateCareTeamMemberSuccess: () => {
            goBack();
        },
    });
    return (
        <>
            <ProfileHeaderContainer profileId={route.params.profileId} bottomBorder omitChatButton>
                <CareTeamActionButtonFrom
                    onSubmit={(careTeamMember) =>
                        createCareTeamMember({
                            ...careTeamMember,
                            associatedResourceId: route.params.associatedResourceId || null,
                        })
                    }
                    isSubmitting={isCreatingCareTeamMember}
                    source={{
                        source: 'profile',
                        medicalProfileId: route.params.profileId,
                    }}
                    shouldRecordAddCareTeamMember
                />
            </ProfileHeaderContainer>
        </>
    );
};

export default React.memo(AddCareTeamMemberScreen);
